class Employee {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.employeeId = data.employeeId || `EMP${Date.now()}`;
      this.firstName = data.firstName || '';
      this.lastName = data.lastName || '';
      this.email = data.email || '';
      this.phone = data.phone || '';
      this.dateOfBirth = data.dateOfBirth || '';
      this.gender = data.gender || '';
      this.address = data.address || '';
      this.department = data.department || '';
      this.designation = data.designation || '';
      this.joiningDate = data.joiningDate || '';
      this.employmentType = data.employmentType || 'Full-time';
      this.status = data.status || 'Active';
      this.salary = data.salary || 0;
      this.createdAt = data.createdAt || new Date().toISOString();
    }
    getFullName() { return `${this.firstName} ${this.lastName}`.trim(); }
    getStatusColor() {
      const colors = { 'Active': '#10b981', 'Inactive': '#ef4444', 'On Leave': '#f59e0b' };
      return colors[this.status] || '#6b7280';
    }
    validate() {
      const errors = [];
      if (!this.firstName?.trim()) errors.push('First name required');
      if (!this.lastName?.trim()) errors.push('Last name required');
      if (!this.email?.trim()) errors.push('Email required');
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) errors.push('Invalid email');
      if (!this.department) errors.push('Department required');
      return { isValid: errors.length === 0, errors };
    }
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Employee(json); }
  }
  export default Employee;